import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Award, ShieldX, ShieldCheck } from "lucide-react";
import api from "@/lib/api";
import { TRAIN } from "@/constants/testIds";
import CosmicBackground from "@/components/lifted/CosmicBackground";
import Brand from "@/components/lifted/Brand";

export default function VerifyCertificate() {
  const { code } = useParams();
  const [state, setState] = useState({ loading: true, result: null });

  useEffect(() => {
    api.get(`/verify/${code}`).then((r) => setState({ loading: false, result: r.data }))
       .catch(() => setState({ loading: false, result: { valid: false } }));
  }, [code]);

  return (
    <>
      <CosmicBackground />
      <div className="min-h-screen p-8 flex flex-col">
        <Brand to="/" />
        <div className="flex-1 flex items-center justify-center">
          <div className="glass-panel p-10 max-w-xl w-full fade-up text-center">
            {state.loading ? (
              <div className="font-bebas tracking-[0.3em] text-lifted-dim">VERIFYING…</div>
            ) : state.result?.valid ? (
              <div data-testid={TRAIN.publicVerifyValid}>
                <Award className="h-12 w-12 text-lifted-green mx-auto" />
                <div className="eyebrow mt-4 mb-1">Verified certificate</div>
                <h1 className="font-anton text-4xl uppercase">
                  <span data-testid={TRAIN.publicVerifyName}>{state.result.certificate.user_name}</span>
                </h1>
                <p className="text-lifted-dim mt-2">
                  is certified as a Lifted{" "}
                  <span data-testid={TRAIN.publicVerifyTrack} className="text-lifted-green">
                    {state.result.certificate.track_title}
                  </span>
                </p>
                <div className="mt-5 grid grid-cols-2 gap-3 text-sm">
                  <div className="glass-panel p-3"><div className="eyebrow !text-lifted-text-dim">Score</div><div className="font-anton text-2xl text-lifted-green">{state.result.certificate.score}</div></div>
                  <div className="glass-panel p-3"><div className="eyebrow !text-lifted-text-dim">Issued</div><div className="font-anton text-sm text-lifted-text mt-1">{state.result.certificate.issued_at?.slice(0, 10)}</div></div>
                </div>
                <code className="block mt-5 text-xs text-lifted-mute">code · {state.result.certificate.verification_code}</code>
              </div>
            ) : (
              <div data-testid={TRAIN.publicVerifyInvalid}>
                {state.result?.revoked
                  ? <ShieldX className="h-12 w-12 text-rose-300 mx-auto" />
                  : <ShieldCheck className="h-12 w-12 text-lifted-mute mx-auto" />}
                <h1 className="font-anton text-3xl uppercase mt-4">
                  {state.result?.revoked ? "Certificate revoked" : "Not a valid certificate"}
                </h1>
                <p className="text-lifted-dim mt-2">The verification code <code className="text-lifted-text">{code}</code> {state.result?.revoked ? "was revoked." : "could not be verified."}</p>
              </div>
            )}
          </div>
        </div>
        <footer className="text-center text-[0.65rem] tracking-[0.3em] font-bebas text-lifted-mute mt-8">
          LIFTED ECOSYSTEM · CERTIFICATE VERIFICATION
        </footer>
      </div>
    </>
  );
}
